import {
  Button,
  Box,
  HStack,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { FileWithPath } from 'react-dropzone';
import { mixed, object } from 'yup';

import { UploadReceivablesFileDropzone } from './UploadReceivablesFileDropzone';

// Exports
type Props = {
  onClose: () => void;
  handleFile: (file: File) => void;
};
export const UploadReceivablesFileForm = ({ onClose, handleFile }: Props) => {
  const [loading, setLoading] = useState(false);

  const buttonColorScheme = useColorModeValue('aurora', 'gray');

  return (
    <Formik
      onSubmit={async (values) => {
        try {
          if (values && values.file) {
            handleFile(values.file);
          }
        } catch (err) {
          setLoading(false);
          throw err;
        }
        setLoading(false);
        onClose();
      }}
      validationSchema={object().shape({
        file: mixed(),
      })}
      initialValues={{
        file: null,
      }}
      validateOnChange={false}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <Form onSubmit={handleSubmit}>
          <VStack spacing="10px">
            <UploadReceivablesFileDropzone
              isDisabled={loading}
              setFieldValue={(value: FileWithPath) =>
                setFieldValue(`file`, value)
              }
            />
            <Box py="12px" alignSelf="flex-end">
              <HStack spacing="25px">
                <Button
                  variant="outline"
                  colorScheme={buttonColorScheme}
                  onClick={onClose}
                  px="20px"
                >
                  Cancel
                </Button>
                <Button
                  variant="solid"
                  colorScheme={buttonColorScheme}
                  isDisabled={!values.file}
                  isLoading={loading}
                  type="submit"
                  px="20px"
                >
                  Upload
                </Button>
              </HStack>
            </Box>
          </VStack>
        </Form>
      )}
    </Formik>
  );
};
